// action constants
import { LayoutActionTypes, LayoutStateTypes } from './constants';

// app constants
import {
    LayoutTypes,
    LayoutWidth,
    MenuPositions,
    SideBarTheme,
    SideBarTypes,
    TopbarTheme,
} from '../../constants/layout';

// actions
import { LayoutActionType } from './actions';

// utils
import { getLayoutConfigs } from '../../utils';

const getStoredLayout = () => {
    try {
        const stored = localStorage.getItem('layout_settings');
        return stored ? JSON.parse(stored) : null;
    } catch {
        return null;
    }
};

const persistLayout = (state: any) => {
    try {
        localStorage.setItem('layout_settings', JSON.stringify(state));
    } catch (e) {
        console.error("Error saving layout settings:", e);
    }
};

const stored = getStoredLayout();

const INIT_STATE = {
    layoutType: stored?.layoutType ?? LayoutTypes.LAYOUT_VERTICAL,
    layoutWidth: stored?.layoutWidth ?? LayoutWidth.LAYOUT_WIDTH_FLUID,
    menuPosition: stored?.menuPosition ?? MenuPositions.MENU_POSITION_FIXED,
    leftSideBarTheme: stored?.leftSideBarTheme ?? SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT,
    leftSideBarType: stored?.leftSideBarType ?? SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT,
    showSidebarUserInfo: stored?.showSidebarUserInfo ?? false,
    topbarTheme: stored?.topbarTheme ?? TopbarTheme.TOPBAR_THEME_LIGHT,
    isOpenRightSideBar: false,
};

const Layout = (state: LayoutStateTypes = INIT_STATE, action: LayoutActionType<string | boolean | null>) => {
    let newState;
    switch (action.type) {
        case LayoutActionTypes.CHANGE_LAYOUT:
            newState = {
                ...state,
                layoutType: action.payload,
            };
            break;
        case LayoutActionTypes.CHANGE_LAYOUT_WIDTH:
            const layoutConfig = getLayoutConfigs(action.payload! && action.payload);
            newState = {
                ...state,
                layoutWidth: action.payload,
                ...layoutConfig,
            };
            break;
        case LayoutActionTypes.CHANGE_MENU_POSITIONS:
            newState = {
                ...state,
                menuPosition: action.payload,
            };
            break;
        case LayoutActionTypes.CHANGE_SIDEBAR_THEME:
            newState = {
                ...state,
                leftSideBarTheme: action.payload,
            };
            break;
        case LayoutActionTypes.CHANGE_SIDEBAR_TYPE:
            newState = {
                ...state,
                leftSideBarType: action.payload,
            };
            break;
        case LayoutActionTypes.TOGGLE_SIDEBAR_USER_INFO:
            newState = {
                ...state,
                showSidebarUserInfo: action.payload,
            };
            break;
        case LayoutActionTypes.CHANGE_TOPBAR_THEME:
            newState = {
                ...state,
                topbarTheme: action.payload,
            };
            break;
        case LayoutActionTypes.SHOW_RIGHT_SIDEBAR:
            return {
                ...state,
                isOpenRightSideBar: true,
            };
        case LayoutActionTypes.HIDE_RIGHT_SIDEBAR:
            return {
                ...state,
                isOpenRightSideBar: false,
            };
        default:
            return state;
    }

    persistLayout(newState);
    return newState;
};

export default Layout;
